import {
  LOAModalForm,
  LOAModalSchema,
} from 'screens/Inventory/NonGRTInvoices/LOAModal/schemas';
import {
  RebillInvoiceDetails,
  RebillLocationsInfo,
} from 'screens/Inventory/NonGRTInvoices/RebillServiceDetailsModal/schemas';

const dataURLToBlob = (dataURL: string): Blob => {
  const [header, base64] = dataURL.split(',');
  const mimeMatch = header.match(/^data:(.*?)(;|,)/);
  const mime = mimeMatch?.[1] || 'image/png';
  const binary = atob(base64);
  const len = binary.length;
  const u8 = new Uint8Array(len);
  for (let i = 0; i < len; i++) u8[i] = binary.charCodeAt(i);
  return new Blob([u8], { type: mime });
};

export const buildLOAPayload = (data: LOAModalForm): FormData => {
  const parsed = LOAModalSchema.parse(data);

  const formData = new FormData();

  formData.append('contact_name', parsed.contact_name);

  const sigBlob = dataURLToBlob(parsed.signature);
  const ext = sigBlob.type === 'image/jpeg' ? 'jpg' : 'png';

  formData.append('file', sigBlob, `signature.${ext}`);

  const logo = parsed.attachments?.[0];
  if (logo) {
    formData.append('file', logo, logo.name);
  }

  return formData;
};

export const buildInvoiceRebillPayload = (
  data: RebillLocationsInfo & RebillInvoiceDetails,
) => {
  return {
    locations: [
      {
        address: {
          ...data.site,
          address1: data.site?.address_line_1 || '',
          address2: data.site?.address_line_2 || '',
          city: data.site?.city || '',
          state: data.site?.state || '',
          zip: data.site?.zip || '',
          business_name: data.business_name || '',
          unit: data.unit || '',
          billing_type: data.billing_type?.value ?? null,
          invoice_style: data.invoice_style?.value ?? null,
          invoice_delivery_method: data.invoice_delivery_method?.value ?? null,
          ...(!data.site?.macnum
            ? {
                parent_macnum: data.parent_account?.value,
                parent_name: data.parent_account?.label,
              }
            : {}),
        },
        source: 'REBILL',
        services: data.services.map((svc) => {
          let normalizedSpeed: string | undefined;

          if (svc.bandwidth) {
            const num = Number(svc.bandwidth.amount);
            const unit = svc.bandwidth.unit.value;
            normalizedSpeed =
              unit === 'Gbps' ? String(num * 1000) : String(num);
          }
          const base = {
            type: svc.service_type.value,
            identifier: svc.service_identifier || '',
            vendor_name: data.vendor_name,
            vendor_account_number: data.vendor_account_number,
            mrc: typeof data.mrc === 'string' ? parseFloat(data.mrc) : data.mrc,
            contract_start_date: data.contract_start_date || null,
            contract_end_date: data.contract_end_date || null,
            extra_details: {} as Record<string, string | undefined | null>,
          };

          switch (svc.service_type.value) {
            case 'Broadband':
            case 'DIA':
            case 'PIP/GSE':
              base.extra_details = {
                subtype: svc.subtype,
                data_speed: normalizedSpeed,
              };
              break;

            case 'Mobility':
              base.extra_details = {
                data_speed: normalizedSpeed,
              };
              break;

            case 'DID':
            case 'POTS':
            case 'RCF':
            case 'SIP':
            case 'Toll-Free':
            case 'LD':
            case 'Hosted PBX/EPOTS':
              base.identifier = svc.btn || '';
              base.extra_details = Object.fromEntries(
                (svc.wtns || []).map((wtn, i) => [`wtn_${i + 1}`, wtn]),
              );
              break;

            case 'Television':
              break;
          }

          return base;
        }),
      },
    ],
  };
};
